/**
 * This is a dirty hack to create an object URL from a src.
 * Currently, the server cannot provide a proper CORS header with the asset
 * so when it's loaded via src in the image or video tag it's cached
 * and when we fetch it again via the script, the cors headers are missing
 * and the asset is not loaded.
 *
 * We fetch the asset via the fetch API and create an object URL from the response.
 * This helps us to get the asset with the proper CORS headers and have it in the cache.
 *
 * TODO: Remove this as soon as the server provides the proper CORS headers for all types of requests.
 */

import { useEffect, useState } from 'react';
import { useAssetCache } from '~/pages/app/creative/editor/AseetsCache';

export default function useObjectUrl(src: string | undefined): string | undefined {
    const [objectUrl, setObjectUrl] = useState<string>();
    const response = useAssetCache(src);
    const [retries, setRetries] = useState(0);

    useEffect(() => {
        if (!src) {
            return;
        }

        let currentObjectUrl: string;
        let timeoutId;

        (response ?? fetch(src))
            .then((response) => response.blob())
            .then((blob) => {
                currentObjectUrl = URL.createObjectURL(blob);
                setObjectUrl(currentObjectUrl);
                setRetries(0);
            })
            .catch(() => {
                if (retries < 3) {
                    timeoutId = setTimeout(() => {
                        setRetries((prev) => prev + 1);
                    }, retries * 1000);
                }
            });

        return () => {
            setObjectUrl(undefined);
            clearTimeout(timeoutId);

            // Revoke the object URL after a short delay to make sure state is updated
            setTimeout(() => {
                URL.revokeObjectURL(currentObjectUrl);
            }, 100);
        };
    }, [src, retries, response]);

    return objectUrl;
}
